import cx from "classnames";
import React from "react";

//cleans up any addtional properties passed to group used by formlayout
export const IFXFieldGroup = ({ children }) => <>{children}</>;
